import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/tenant/applications/application/root'

export const securityRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/security',
    component: lazyRouteComponent(() => import('./Security'), 'Security'),
    loader: ({ parentMatchPromise }) => parentMatchPromise,
})
